import React from 'react';
import { theme } from '../theme';

// ─── PanelSection ───────────────────────────────────────
export const PanelSection: React.FC<{
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  expanded?: boolean;
  onToggle?: () => void;
  headerAction?: React.ReactNode;
}> = ({ title, children, collapsible, expanded, onToggle, headerAction }) => (
  <div style={{ marginBottom: theme.spacing.lg }}>
    <h3 style={{
      margin: `0 0 ${theme.spacing.sm}px 0`,
      display: 'flex', alignItems: 'center', gap: theme.spacing.sm,
    }}>
      <span style={{ flex: 1, fontSize: 14, fontWeight: 600, color: theme.colors.navy }}>
        {collapsible ? (
          <button
            type="button"
            onClick={onToggle}
            aria-expanded={!!expanded}
            style={{
              background: 'none', border: 'none', padding: 0, margin: 0,
              font: 'inherit', color: 'inherit', cursor: 'pointer',
              userSelect: 'none', display: 'flex', alignItems: 'center', gap: theme.spacing.xs,
            }}
          >
            {title}
            <span style={{ fontSize: 10, color: theme.colors.accentOrange }}>
              {expanded ? '\u25B2' : '\u25BC'}
            </span>
          </button>
        ) : title}
      </span>
      {headerAction && (
        <div style={{ flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: theme.spacing.xs }}>
          {headerAction}
        </div>
      )}
    </h3>
    {(!collapsible || expanded) && children}
  </div>
);
